export const config = {
  notificationApiUrl: process.env.NEXT_PUBLIC_NOTIFICATION_API_URL || '',
  notificationApiKey: process.env.NEXT_PUBLIC_NOTIFICATION_API_KEY || '',
  flowApiUrl: process.env.FLOW_API_URL || '',
  flowApiKey: process.env.FLOW_API_KEY || '',
};

export const featureFlags = {
  // Feature flag para habilitar/desabilitar a página de welcome/onboarding
  // Para ativar, defina NEXT_PUBLIC_ENABLE_WELCOME_PAGE=true
  enableWelcomePage: true,
};
